import { render, staticRenderFns } from "./BaseMain.vue?vue&type=template&id=5c9cb8c8"
import script from "./BaseMain.vue?vue&type=script&lang=js"
export * from "./BaseMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports